"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MCNVault = exports.VaultWallet = void 0;
const utils_1 = require("../utils");
const account_1 = require("./account");
function getAccountId(provider, wallet) {
    const jvmId = wallet.getWallet(provider.jvmChain).getKeyPair().publicKey;
    const evmId = wallet.getWallet(provider.juneChain).getKeyPair().publicKey;
    return `${jvmId}_${evmId}`;
}
class VaultWallet {
    provider;
    wallet;
    constructor(provider, wallet) {
        this.provider = provider;
        this.wallet = wallet;
    }
    getJVMAddress() {
        return this.wallet.getAddress(this.provider.jvmChain);
    }
    getEVMAddress() {
        return this.wallet.getAddress(this.provider.juneChain);
    }
    getIdentifier() {
        return getAccountId(this.provider, this.wallet);
    }
}
exports.VaultWallet = VaultWallet;
class MCNVault {
    provider;
    account;
    wallets = new Map();
    constructor(provider, mainWallet, wallets = []) {
        this.provider = provider;
        this.account = new account_1.MCNAccount(provider, mainWallet);
        const vaultWallet = new VaultWallet(provider, mainWallet);
        this.wallets.set(vaultWallet.getIdentifier(), vaultWallet);
        this.addWallets(wallets);
    }
    addWallet(wallet) {
        this.addVaultWallet(new VaultWallet(this.provider, wallet));
    }
    addWallets(wallets) {
        for (const wallet of wallets) {
            this.addWallet(wallet);
        }
    }
    addVaultWallet(vaultWallet) {
        if (this.wallets.has(vaultWallet.getIdentifier())) {
            throw new utils_1.VaultError('vault already contains this wallet');
        }
        this.wallets.set(vaultWallet.getIdentifier(), vaultWallet);
        // adding new wallets as signers
        for (const chainAccount of this.account.chainAccounts.values()) {
            if (chainAccount.type === account_1.AccountType.Utxo) {
                const signer = vaultWallet.wallet.getWallet(chainAccount.chain);
                chainAccount.signers.push(signer);
            }
        }
    }
    setMainWallet(vaultWallet) {
        // reset all signers of previous account to avoid errors if switching back to it later
        for (const chainAccount of this.account.chainAccounts.values()) {
            chainAccount.signers = [chainAccount.chainWallet];
        }
        // remove self before adding signers to avoid duplicate signers
        if (this.wallets.has(vaultWallet.getIdentifier())) {
            this.wallets.delete(vaultWallet.getIdentifier());
        }
        this.account = new account_1.MCNAccount(this.provider, vaultWallet.wallet);
        // adding all registered signers to new main account
        for (const chainAccount of this.account.chainAccounts.values()) {
            if (chainAccount.type === account_1.AccountType.Utxo) {
                for (const wallet of this.wallets.values()) {
                    const signer = wallet.wallet.getWallet(chainAccount.chain);
                    chainAccount.signers.push(signer);
                }
            }
        }
        this.wallets.set(vaultWallet.getIdentifier(), vaultWallet);
    }
    removeWallet(wallet) {
        const identifier = getAccountId(this.provider, wallet);
        if (identifier === getAccountId(this.provider, this.account.wallet)) {
            throw new utils_1.VaultError('cannot remove main wallet');
        }
        // removing wallet
        if (!this.wallets.delete(identifier)) {
            throw new utils_1.VaultError('wallet is not in vault');
        }
        // removing signers from chain accounts in mainWallet (= account)
        for (const chainAccount of this.account.chainAccounts.values()) {
            if (chainAccount.type === account_1.AccountType.Utxo) {
                const signers = [];
                for (const vaultWallet of this.wallets.values()) {
                    const signer = vaultWallet.wallet.getWallet(chainAccount.chain);
                    signers.push(signer);
                }
                chainAccount.signers = signers;
            }
        }
    }
    hasWallet(wallet) {
        return this.wallets.has(getAccountId(this.provider, wallet));
    }
    getWallet(identifier) {
        const wallet = this.wallets.get(identifier);
        if (typeof wallet === 'undefined') {
            throw new utils_1.VaultError(`there is no wallet with identifier: ${identifier}`);
        }
        else {
            return wallet;
        }
    }
}
exports.MCNVault = MCNVault;
